
import React from "react";
import { Form, Radio, ConfigProvider } from 'antd';

const RadioField = ({ defaultValue, label, name }) => (
    <ConfigProvider direction="rtl">
        <Form.Item name={name} label={label} labelCol={{ span: 24 }}
            rules={[
                {
                    required: true,
                    message: `لطفا ${label} خود را وارد نمایید!`,
                },
            ]}
        >
            <Radio.Group  buttonStyle="solid" block style={{'width':'100%'}}>
                <Radio.Button value="3">نصب</Radio.Button>
                <Radio.Button value="2">تعمیر</Radio.Button>            
            </Radio.Group>

        </Form.Item>
    </ConfigProvider>
);

export default RadioField;